import React, {useState, useEffect} from "react";

export const Partner = () => {
  const isVisible = (elementOffset) => {
    return scrollY > elementOffset - window.innerHeight + 100;
  };

  return (
    <section className="py-20 px-4 relative">
      <div className="max-w-6xl mx-auto relative z-10">
        <div
          className={`transform transition-all duration-1000 ${
            isVisible(300)
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-10"
          }`}
        >
          <h2 className="text-4xl/[1.5] font-bold text-center mb-16 bg-clip-text text-[#FF4D00]">
            Become a partner festival
          </h2>

            <div className="grid grid-cols-1 gap-12 md:grid-cols-2 mx-auto">
            <div className="flex items-center justify-center p-3 gap-4 mx-auto">
                    <img style={{ width: "75%", height: "auto" }} src={require("../assets/helga_partners3.jpg")}
                        alt="Handshake"/>
                </div>
              <div className="content-center">
                <p className="text-xl text-gray-400 mb-8 max-w-2xl">
                    We are looking for partner festivals to join the Helga platform. 
                </p>
                <p className="text-xl text-gray-400 mb-8 max-w-2xl">
                    We'll provide your visitors with the best festival app out there and make your life as an organizer easier!
                </p>
                <p className="text-xl text-gray-400 mb-8 max-w-2xl">
                    The first festivals to join will receive a huge discount on all of the provided serivces, too!
                </p>
                <p className="text-xl text-gray-400 mb-8 max-w-2xl">
                    Only a few partner slots open for 2025!
                </p>
              </div>
            </div>
          </div>
      </div>
    </section>
  );
};
